import { IAppState } from '../../../AppModulesWrapper';

export function selectActiveServiceIndex(state: IAppState): number | undefined {
  const {
    publishTerms: { selectedServiceId, serviceIds },
  } = state.servicePickerWidget;

  if (!selectedServiceId) {
    return undefined;
  }

  return serviceIds.indexOf(selectedServiceId);
}
